<template>
  <svg v-if="color_1"
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 18V21.766L6.515 20.857L11.277 18H16C17.103 18 18 17.103 18 16V8C18 6.897 17.103 6 16 6H4C2.897 6 2 6.897 2 8V16C2 17.103 2.897 18 4 18H5ZM4 8H16V16H10.723L7 18.234V16H4V8Z"
      fill="url(#ai_chatbot_gradient_1)" />
    <path
      d="M20 2H8C6.897 2 6 2.897 6 4H18C19.103 4 20 4.897 20 6V14C21.103 14 22 13.103 22 12V4C22 2.897 21.103 2 20 2Z"
      fill="url(#ai_chatbot_gradient_2)" />
    <defs>
      <linearGradient id="ai_chatbot_gradient_1"
                      x1="10"
                      y1="6"
                      x2="10"
                      y2="21.766"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
      <linearGradient id="ai_chatbot_gradient_2"
                      x1="14"
                      y1="2"
                      x2="14"
                      y2="14"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
    </defs>
  </svg>

  <svg v-else
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 18V21.766L6.515 20.857L11.277 18H16C17.103 18 18 17.103 18 16V8C18 6.897 17.103 6 16 6H4C2.897 6 2 6.897 2 8V16C2 17.103 2.897 18 4 18H5ZM4 8H16V16H10.723L7 18.234V16H4V8Z"
      :fill="color" />
    <path d="M20 2H8C6.897 2 6 2.897 6 4H18C19.103 4 20 4.897 20 6V14C21.103 14 22 13.103 22 12V4C22 2.897 21.103 2 20 2Z" :fill="color" />
    <defs />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#899399"
    },
    color_1: null,
    color_2: null
  }
}
</script>
